import React, { useState, useRef } from "react";
import TopbarComponent from "../components/Topbar";
import GuidelineComponent from "../components/Guideline";
import "../style.css";
import "../text.css";
import AlertHeader5 from "../components/AlertHeader5";
import ask2 from "../image/aksjdlas.png";
import kakaoaa from "../image/kakaoaa.png";
import nobtn from "../image/nextbtn_new.png";
import new_blue from "../image/new_blue.png";
import AlertHeaderPc3 from "../components/AlertHeaderPc3";
import logograyq from "../image/logograyq.svg";
import logoblueq from "../image/logoblueq.svg";
import samplelogo from "../image/samplelogo.png";
import logocanclebtn from "../image/logocanclebtn.png";
import $ from "jquery";
import {
  BrowserRouter,
  Route,
  Switch,
  Link,
  NavLink,
  useParams,
} from "react-router-dom";
import {
  BrowserView,
  MobileView,
  isBrowser,
  IsMobile,
  TabletView,
} from "react-device-detect";
import BrowserHeader from "../components/BrowserHeader";

function BrandLogoRegister() {
  const [samplelogoTF, setSamplelogoTF] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [brandnamelogo, setBrandnamelogo] = useState(samplelogo);
  const [brandname, setBrandname] = useState();
  const [logoTF, setLogoTF] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltipp, setShowTooltipp] = useState(false);
  const [showTooltippm1, setShowTooltippm1] = useState(false);
  const [showTooltippm2, setShowTooltippm2] = useState(false);
  const [eventcss, setEventcss] = useState("disabled-link");
  // const [eventcss, setEventcss] = useState('');
  const input = useRef(null);
  const img = useRef(null);
  const [src, setSrc] = useState("");
  const [pcq1, setPcq1] = useState(logograyq);
  const [pcq2, setPcq2] = useState(logograyq);
  const [mq1, setMq1] = useState(logograyq);
  const [mq2, setMq2] = useState(logograyq);
  const [img1, setText1] = useState(["categorybox11"]);
  const [img2, setText2] = useState(["categorybox11"]);
  const [nextbtn, setNextbtn] = useState(nobtn);
  const [img11, setText11] = useState(["categorybox111"]);
  const [img22, setText22] = useState(["categorybox111"]);
  const [filename, setFilename] = useState([""]);
  const [logochangebtn, setLogochangebtn] = useState("로고 첨부(Click!)");
  const tooltipRef = useRef(null);
  const tooltipRef2 = useRef(null);
  const handleWrapperClick = (e) => {
    // tooltip 바깥 클릭 시만 닫기
    if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
      setShowTooltippm1(false);
    }
  };
  const handleWrapperClick2 = (e) => {
    if (tooltipRef2.current && !tooltipRef2.current.contains(e.target)) {
      setShowTooltippm2(false);
    }
  };
  function fileUpload() {
    let file = input.current.files[0];

    var maxSize = 5 * 1024 * 1024;
    var fileSize = file.size;

    if (fileSize > maxSize) {
      alert("첨부파일 사이즈는 5MB 이내로 등록 가능합니다.");
      return false;
    } else {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSrc(e.target.result);
        setBrandnamelogo(e.target.result);
      };

      reader.readAsDataURL(file);
      setEventcss("");
      setFilename([file.name]);
      setUploadedFile(file);
      setNextbtn(new_blue);
      $("#next_button").css("background-color", "#4a64f5");
      $("#dam").css("color", "#ffffff");
      setLogochangebtn("파일 변경(Click!)");
    }
  }
  function cancelUpload() {
    // input 초기화
    if (input.current) {
      input.current.value = "";
    }

    // 상태 초기화
    setSrc("");
    setBrandnamelogo(samplelogo); // 또는 "" 등 초기값
    setFilename([""]);
    setEventcss("disabled-link");
    setNextbtn(nobtn); // 필요 시 원래 버튼으로
    setLogochangebtn("로고 첨부(Click!)"); // 버튼 문구 초기화
    $("#next_button").css("background-color", "#efefef");
    $("#dam").css("color", "#b7b7b7");
    setUploadedFile(null);
  }
  const onClick1 = (i) => {
    if (i == 1) {
      if (img1[0] == "categorybox11") {
        setText1(["categorybox22"]);
        setText2(["categorybox11"]);
        $("#next_button").css("background-color", "#4a64f5");
        $("#dam").css("color", "#ffffff");
        setEventcss("");
        setLogoTF(false);
        setMq1(logoblueq);
        setMq2(logograyq);
        setSamplelogoTF(false);
        let brand = sessionStorage.getItem("brandname");
        setBrandname(brand);
      } else {
        setText1(["categorybox11"]);
        $("#next_button").css("background-color", "#efefef");
        $("#dam").css("color", "#b7b7b7");
        setEventcss("disabled-link");
        setLogoTF(false);
        setMq1(logograyq);
        setMq2(logograyq);
        setSamplelogoTF(false);
        setBrandname();
      }
    } else {
      if (img2[0] == "categorybox11") {
        setText2(["categorybox22"]);
        setText1(["categorybox11"]);
        $("#next_button").css("background-color", "#efefef");
        $("#dam").css("color", "#b7b7b7");
        setLogoTF(true);
        setMq1(logograyq);
        setMq2(logoblueq);
        setBrandname();
        setSamplelogoTF(true);
        if (brandnamelogo != samplelogo) {
          $("#next_button").css("background-color", "#4a64f5");
          $("#dam").css("color", "#ffffff");
          setEventcss("");
        } else {
          setEventcss("disabled-link");
        }
      } else {
        setText2(["categorybox11"]);
        $("#next_button").css("background-color", "#efefef");
        $("#dam").css("color", "#b7b7b7");
        setEventcss("disabled-link");
        setMq1(logograyq);
        setMq2(logograyq);
        setLogoTF(false);
        setSamplelogoTF(false);
        setBrandname();
      }
    }
  };
  const onClick11 = (i) => {
    if (i == 1) {
      if (img11[0] == "categorybox111") {
        setText11(["categorybox222"]);
        setText22(["categorybox111"]);
        setPcq1(logoblueq);
        setPcq2(logograyq);
        setSamplelogoTF(false);
        let brand = sessionStorage.getItem("brandname");
        setBrandname(brand);
        $("#next_button").css("background-color", "#4a64f5");
        $("#dam").css("color", "#ffffff");
        setEventcss("");
        setLogoTF(false);
        setShowTooltipp(false);
        setNextbtn(new_blue);
      } else {
        setText11(["categorybox111"]);
        setPcq1(logograyq);
        setPcq2(logograyq);
        setBrandname();
        setSamplelogoTF(false);
        setShowTooltip(false);
        $("#next_button").css("background-color", "#efefef");
        $("#dam").css("color", "#b7b7b7");
        setEventcss("disabled-link");
        setLogoTF(false);
        setNextbtn(nobtn);
      }
    } else {
      if (img22[0] == "categorybox111") {
        setText22(["categorybox222"]);
        setText11(["categorybox111"]);
        setPcq1(logograyq);
        setPcq2(logoblueq);
        setShowTooltip(false);
        setBrandname();
        setSamplelogoTF(true);
        $("#next_button").css("background-color", "#efefef");
        $("#dam").css("color", "#b7b7b7");
        setLogoTF(true);
        // setNextbtn(nobtn);
        if (brandnamelogo != samplelogo) {
          setNextbtn(new_blue);
        } else {
          setNextbtn(nobtn);
        }
      } else {
        setText22(["categorybox111"]);
        setPcq1(logograyq);
        setPcq2(logograyq);
        setBrandname();
        setSamplelogoTF(false);
        setShowTooltipp(false);
        $("#next_button").css("background-color", "#efefef");
        $("#dam").css("color", "#b7b7b7");
        setEventcss("disabled-link");
        setNextbtn(nobtn);
        setLogoTF(false);
      }
    }
  };
  const saveLogo = () => {
    let formData = new FormData();
    let inputimage = document.getElementById("file-1");

    if (inputimage == null) {
      window.location.replace("/brandcategoryregister");
    } else {
      let file = inputimage.files[0];
      let token2 = sessionStorage.getItem("token");
      formData.append("filedata", uploadedFile, uploadedFile.name);
      formData.append("filename", uploadedFile.name);
      formData.append("token", token2);
      $.ajax({
        type: "POST",
        url: "https://nametecadmin.kr/savelogo",
        enctype: "multipart/form-data",
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        timeout: 6000000,

        success: function (data) {
          if (data.status == 200) {
            window.location.replace("/brandcategoryregister");
          } else {
          }
        },
        err: function (err) {
          alert(err.status);
        },
      });
    }
  };
  const combinedClickHandler = (e) => {
    handleWrapperClick(e);
    handleWrapperClick2(e);
  };
  return (
    <div>
      <MobileView>
        <div
          onClickCapture={combinedClickHandler}
          style={{ margin: "auto", maxWidth: "520px" }}
        >
          <TopbarComponent page={"02"} path={"/brandregister"} />
          <AlertHeader5 />
          <div style={{ width: "342px", margin: "auto" }}>
            <GuidelineComponent
              title1="상표 등록 유형을"
              title2={"선택해주세요"}
              help2={"."}
              help={"로고가 있는 경우, 파일을 준비해주세요."}
            ></GuidelineComponent>
          </div>
          <div style={{ marginTop: "-45px" }}>
            <div
              id="1"
              onClick={() => onClick1(1)}
              style={{
                fontSize: "16px",
                lineHeight: "1",
                marginLeft: "20px",
                marginTop: "120px",
              }}
              className={img1[0]}
            >
              <div
                style={{
                  display: "inline-block",
                  marginLeft: "10px",
                  lineHeight: "1.2",
                }}
              >
                <a className="Bold1">로고가 없습니다 (문자로 상표출원 진행)</a>
                <img
                  loading="lazy"
                  onClick={(e) => {
                    if (img1[0] === "categorybox22") {
                      e.stopPropagation();
                      if (showTooltippm1 === true) {
                        setShowTooltippm1(false);
                      } else {
                        setShowTooltippm1(true);
                      }
                    }
                  }}
                  src={mq1}
                  alt="info"
                  style={{
                    width: "16px",
                    position: "absolute",
                    marginTop: "2.5px",
                    marginLeft: "4px",
                  }}
                />
                {showTooltippm1 && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    ref={tooltipRef}
                    style={{
                      position: "absolute",
                      width: "282px",
                      backgroundColor: "#4f6df5",
                      color: "#fff",
                      padding: "8px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      textAlign: "left",
                      zIndex: 999,
                      marginTop: "-144px",
                      marginLeft: "18px",
                      opacity: "0.95",
                    }}
                  >
                    {/* 꼬리 */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "-8px", // 툴팁 아래에 위치
                        right: "49px", // 오른쪽 끝에서 약간 안쪽
                        width: 0,
                        height: 0,
                        borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent",
                        borderTop: "10px solid #4f6df5", // 위 방향으로 뾰족
                      }}
                    />

                    {/* 내용 */}
                    <div
                      className="Medium"
                      style={{ marginBottom: "8px", fontSize: "14px" }}
                    >
                      문자 상표 기준
                    </div>
                    <div className="Light1" style={{ fontSize: "14px" }}>
                      ① 로고 없이 상표명만 있는 경우
                    </div>
                    <div className="Light1" style={{ fontSize: "14px" }}>
                      ② 도형, 심볼 없이 폰트로만 이루어진 로고
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;(캘리그래피 로고도 동일)
                    </div>
                    <div
                      className="Regular"
                      style={{ marginTop: "8px", fontSize: "14px" }}
                    >
                      *판단이 어려운 경우 우선 로고를 업로드 해주세요 :)
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              id="2"
              onClick={() => onClick1(2)}
              style={{
                fontSize: "16px",
                lineHeight: "1",
                marginTop: "10px",
                marginLeft: "20px",
              }}
              className={img2[0]}
            >
              <div
                style={{
                  display: "inline-block",
                  marginLeft: "10px",
                  lineHeight: "1.2",
                }}
              >
                <a className="Bold1">로고가 있습니다 (로고로 상표출원 진행)</a>
                <img
                  loading="lazy"
                  onClick={(e) => {
                    if (img2[0] === "categorybox22") {
                      e.stopPropagation();
                      if (showTooltippm2 === true) {
                        setShowTooltippm2(false);
                      } else {
                        setShowTooltippm2(true);
                      }
                    }
                  }}
                  src={mq2}
                  alt="info"
                  style={{
                    width: "16px",
                    position: "absolute",
                    marginTop: "2.5px",
                    marginLeft: "4px",
                  }}
                />
                {showTooltippm2 && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    ref={tooltipRef2}
                    style={{
                      position: "absolute",
                      width: "282px",
                      backgroundColor: "#4f6df5",
                      color: "#fff",
                      padding: "8px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      textAlign: "left",
                      zIndex: 999,
                      marginTop: "11px",
                      marginLeft: "18px",
                      opacity: "0.95",
                    }}
                  >
                    {/* 꼬리 */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-8px", // 툴팁 아래에 위치
                        right: "49px", // 오른쪽 끝에서 약간 안쪽
                        width: 0,
                        height: 0,
                        borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent",
                        borderBottom: "10px solid #4f6df5", // 위 방향으로 뾰족
                      }}
                    />

                    {/* 내용 */}
                    <div
                      className="Medium"
                      style={{ marginBottom: "8px", fontSize: "14px" }}
                    >
                      로고 상표 기준
                    </div>
                    <div className="Light1" style={{ fontSize: "14px" }}>
                      ➀ 글씨 없이 도형, 심볼로만 이루어져 있는 로고
                    </div>
                    <div className="Light1" style={{ fontSize: "14px" }}>
                      ➁ 글씨와 도형, 심볼의 조합으로 된 로고
                    </div>
                    <div
                      className="Regular"
                      style={{ marginTop: "8px", fontSize: "14px" }}
                    >
                      *판단이 어려운 경우 우선 로고를 업로드 해주세요 :)
                    </div>
                  </div>
                )}
              </div>
            </div>
            {logoTF ? (
              <>
                <input
                  type="file"
                  accept="image/*,.pdf,.png"
                  name="file-1[]"
                  id="file-1"
                  onChange={fileUpload}
                  ref={input}
                  className="inputfile inputfile-1"
                  style={{ display: "none", textAlign: "center" }}
                />

                <label htmlFor="file-1">
                  <div
                    className="Light"
                    style={{
                      display: "inline-block",
                      backgroundColor:
                        brandnamelogo === samplelogo ? "#898989" : "#4A64F5",
                      color: "#ffffff",
                      marginTop: "15px",
                      padding: "10px 7px 10px 11px",
                      fontSize: "14px",
                      marginLeft: "20px",
                      width: "103px",
                      cursor: "pointer",
                    }}
                  >
                    {logochangebtn}
                  </div>{" "}
                </label>
                <div
                  className="Medium"
                  style={{
                    display: "inline-block",
                    marginLeft: "6px",
                    fontSize: "16px",
                  }}
                >
                  {filename}
                </div>
                {src && (
                  <img
                    loading="lazy"
                    src={logocanclebtn}
                    onClick={(e) => {
                      e.stopPropagation(); // ← 상위 onClick 차단
                      cancelUpload(); // ← 업로드 취소 함수 호출
                    }}
                    style={{
                      width: "17px",
                      cursor: "pointer",
                      verticalAlign: "middle",
                      marginLeft: "5px",
                    }}
                  />
                )}
                <div
                  style={{
                    fontSize: "14px",
                    marginTop: "15px",
                    color: "#4a64f5",
                    marginLeft: "20px",
                  }}
                >
                  *로고가 있는 경우, 로고 파일을 첨부해주셔야 진행됩니다 :)
                </div>
                <div
                  style={{
                    marginTop: "15px",
                    color: "#898989",
                    fontSize: "14px",
                    marginLeft: "20px",
                    lineHeight: "1.45",
                  }}
                >
                  권장사이즈 : 최소 100 * 100px 이상.
                  <br />
                  파일형식 : jpg, jpeg, gif, png
                  <br />
                  파일 용량 : 최대 5MB 까지.
                </div>
              </>
            ) : (
              <></>
            )}
            <div
              style={{
                padding: "30px 20px",
                backgroundColor: "#fafafa",
                height: "264px",
                textAlign: "center",
                marginLeft: "20px",
                marginRight: "20px",
                marginTop: "30px",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
                className="Medium1"
              >
                상표 견본
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#515151",
                  marginBottom: "20px",
                }}
                className="Light1"
              >
                상표는 아래의 견본으로 등록합니다.
                <br />
                견본은 출원 접수 이전에 수정 가능합니다.
              </div>
              <div
                style={{
                  width: "300px",
                  height: "150px",
                  border: "1px dashed #707070",
                  backgroundColor: "#fff",
                  marginLeft: "calc(50% - 150px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize:
                    (brandname?.length || 0) > 33
                      ? "7px"
                      : (brandname?.length || 0) > 20
                      ? "10px"
                      : (brandname?.length || 0) > 15
                      ? "15px"
                      : (brandname?.length || 0) > 11
                      ? "20px"
                      : "28px",
                  lineHeight: "1.4",
                }}
                className="Bold1"
              >
                {brandname}
                {samplelogoTF && (
                  <img
                    loading="lazy"
                    src={brandnamelogo}
                    style={{
                      maxHeight: "110px",
                      maxWidth: "270px",
                      marginTop: "5px",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div style={{ height: "100px" }}></div>
          <div
            id="next_button"
            className={eventcss}
            onClick={saveLogo}
            style={{
              cursor: "pointer",
              position: "fixed",
              bottom: "0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#efefef",
            }}
          >
            <div id="dam" className="noto" style={{ color: "#b7b7b7" }}>
              {" "}
              다음
            </div>
          </div>
        </div>
      </MobileView>
      <BrowserView>
        <div style={{ margin: "0 auto" }}>
          <BrowserHeader />
          <AlertHeaderPc3 />
          <div style={{ width: "1400px", paddingLeft: "calc(50% - 700px)" }}>
            <img
              loading="lazy"
              src={ask2}
              style={{
                marginTop: "123px",
                marginLeft: "calc(50% - 602px)",
                width: "730px",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "50px",
                fontSize: "20px",
                textAlign: "center",
                fontSize: "20px",
              }}
              className="Medium"
            >
              {/* 왼쪽 선택 영역 */}
              <div style={{ marginRight: "40px" }}>
                <div
                  id="1"
                  onClick={() => onClick11(1)}
                  className={img11[0]}
                  style={{
                    boxShadow: "1px 1px 4px 0 rgba(0, 0, 0, 0.16)",
                    width: "370px",
                    height: "100px",
                    marginBottom: "20px", // 아래 요소와의 간격
                    paddingTop: "50px",
                    cursor: "pointer",
                  }}
                >
                  문자 상표로 출원합니다
                  <br />
                  (상표 견본 그대로 출원)
                  <img
                    loading="lazy"
                    src={pcq1}
                    onClick={(e) => {
                      if (img11[0] === "categorybox222") {
                        e.stopPropagation();
                        if (showTooltip === true) {
                          setShowTooltip(false);
                        } else {
                          setShowTooltip(true);
                        }
                      }
                    }}
                    alt="info"
                    style={{
                      width: "19px",
                      position: "absolute",
                      marginTop: "3px",
                      marginLeft: "4px",
                    }}
                  />
                  {showTooltip && img11[0] === "categorybox222" && (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        width: "362px",
                        backgroundColor: "#4f6df5",
                        color: "#fff",
                        padding: "16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        textAlign: "left",
                        zIndex: 999,
                        marginTop: "-30px",
                        marginLeft: "315px",
                        opacity: "0.95",
                      }}
                    >
                      {/* 꼬리 */}
                      <div
                        style={{
                          position: "absolute",
                          top: "14px",
                          left: "-9.5px",
                          width: 0,
                          height: 0,
                          borderTop: "6px solid transparent",
                          borderBottom: "6px solid transparent",
                          borderRight: "10px solid #4f6df5",
                        }}
                      />

                      {/* 내용 */}
                      <div
                        className="Medium"
                        style={{ marginBottom: "8px", fontSize: "18px" }}
                      >
                        문자 상표 기준
                      </div>
                      <div className="Light1" style={{ fontSize: "18px" }}>
                        ① 로고 없이 상표명만 있는 경우
                      </div>
                      <div className="Light1" style={{ fontSize: "18px" }}>
                        ② 도형, 심볼 없이 폰트로만 이루어진 로고
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;(캘리그래피 로고도 동일)
                      </div>
                      <div
                        className="Regular"
                        style={{ marginTop: "8px", fontSize: "18px" }}
                      >
                        *판단이 어려운 경우 우선 로고를 업로드 해주세요 :)
                      </div>

                      {/* 닫기 X */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTooltip(false);
                        }}
                        className="Light1"
                        style={{
                          position: "absolute",
                          top: "-2px",
                          right: "7px",
                          cursor: "pointer",
                          fontSize: "25px",
                        }}
                      >
                        ×
                      </div>
                    </div>
                  )}
                </div>

                <div
                  id="2"
                  onClick={() => onClick11(2)}
                  className={img22[0]}
                  style={{
                    boxShadow: "1px 1px 4px 0 rgba(0, 0, 0, 0.16)",
                    width: "370px",
                    height: "100px",
                    marginBottom: "20px", // 아래 요소와의 간격
                    paddingTop: "50px",
                    cursor: "pointer",
                  }}
                >
                  로고 상표로 출원합니다
                  <br />
                  (로고 파일 첨부 필요)
                  <img
                    loading="lazy"
                    onClick={(e) => {
                      if (img22[0] === "categorybox222") {
                        e.stopPropagation();
                        if (showTooltipp === true) {
                          setShowTooltipp(false);
                        } else {
                          setShowTooltipp(true);
                        }
                      }
                    }}
                    src={pcq2}
                    alt="info"
                    style={{
                      width: "19px",
                      position: "absolute",
                      marginTop: "3px",
                      marginLeft: "4px",
                    }}
                  />
                  {showTooltipp && img22[0] === "categorybox222" && (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        width: "362px",
                        backgroundColor: "#4f6df5",
                        color: "#fff",
                        padding: "16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        textAlign: "left",
                        zIndex: 999,
                        marginTop: "-30px",
                        marginLeft: "307px",
                        opacity: "0.95",
                      }}
                    >
                      {/* 꼬리 */}
                      <div
                        style={{
                          position: "absolute",
                          top: "14px",
                          left: "-9.5px",
                          width: 0,
                          height: 0,
                          borderTop: "6px solid transparent",
                          borderBottom: "6px solid transparent",
                          borderRight: "10px solid #4f6df5",
                        }}
                      />

                      {/* 내용 */}
                      <div
                        className="Medium"
                        style={{ marginBottom: "8px", fontSize: "18px" }}
                      >
                        로고 상표 기준
                      </div>
                      <div className="Light1" style={{ fontSize: "18px" }}>
                        ➀ 글씨 없이 도형, 심볼로만 이루어져 있는 로고
                      </div>
                      <div className="Light1" style={{ fontSize: "18px" }}>
                        ➁ 글씨와 도형, 심볼의 조합으로 된 로고
                      </div>
                      <div
                        className="Regular"
                        style={{ marginTop: "8px", fontSize: "18px" }}
                      >
                        *판단이 어려운 경우 우선 로고를 업로드 해주세요 :)
                      </div>

                      {/* 닫기 X */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTooltipp(false);
                        }}
                        className="Light1"
                        style={{
                          position: "absolute",
                          top: "-2px",
                          right: "7px",
                          cursor: "pointer",
                          fontSize: "25px",
                        }}
                      >
                        ×
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* 오른쪽 견본 미리보기 영역 */}
              <div
                style={{
                  width: "370px",
                  padding: "30px 20px",
                  backgroundColor: "#fafafa",
                  height: "264px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    marginBottom: "10px",
                  }}
                  className="Bold1"
                >
                  상표 견본
                </div>
                <div
                  style={{
                    fontSize: "18px",
                    color: "#515151",
                    marginBottom: "20px",
                  }}
                  className="Regular"
                >
                  상표는 아래의 견본으로 등록합니다.
                  <br />
                  견본은 출원 접수 이전에 수정 가능합니다.
                </div>
                <div
                  style={{
                    width: "300px",
                    height: "150px",
                    border: "1px dashed #707070",
                    backgroundColor: "#fff",
                    marginLeft: "calc(50% - 150px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize:
                      (brandname?.length || 0) > 33
                        ? "7px"
                        : (brandname?.length || 0) > 20
                        ? "10px"
                        : (brandname?.length || 0) > 15
                        ? "15px"
                        : (brandname?.length || 0) > 11
                        ? "20px"
                        : "28px",
                    lineHeight: "1.4",
                  }}
                  className="Bold1"
                >
                  {brandname}
                  {samplelogoTF && (
                    <img
                      loading="lazy"
                      src={brandnamelogo}
                      style={{
                        maxHeight: "110px",
                        maxWidth: "270px",
                        marginTop: "5px",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            {logoTF ? (
              <>
                <div
                  style={{
                    textAlign: "left",
                    marginLeft: "calc(50% - 400px)",
                    marginTop: "10px",
                  }}
                >
                  <input
                    type="file"
                    accept="image/*,.pdf,.png"
                    name="file-1[]"
                    id="file-1"
                    onChange={fileUpload}
                    ref={input}
                    className="inputfile inputfile-1"
                    style={{ display: "none", textAlign: "center" }}
                  />

                  <label htmlFor="file-1">
                    <div
                      className="Medium"
                      style={{
                        textAlign: "left",
                        display: "inline-block",
                        backgroundColor:
                          brandnamelogo === samplelogo ? "#898989" : "#4A64F5",
                        color: "#ffffff",
                        padding: "10px 7px 10px 11px",
                        fontSize: "20px",
                        width: "143px",
                        cursor: "pointer",
                      }}
                    >
                      {logochangebtn}
                    </div>
                  </label>
                  <div
                    className="Medium"
                    style={{
                      textAlign: "left",
                      display: "inline-block",
                      marginLeft: "15px",
                      fontSize: "20px",
                    }}
                  >
                    {filename}
                  </div>
                  {src && (
                    <img
                      loading="lazy"
                      src={logocanclebtn}
                      onClick={(e) => {
                        e.stopPropagation(); // ← 상위 onClick 차단
                        cancelUpload(); // ← 업로드 취소 함수 호출
                      }}
                      style={{
                        width: "19px",
                        cursor: "pointer",
                        verticalAlign: "middle",
                        marginLeft: "5px",
                      }}
                    />
                  )}
                  <div
                    className="Regular1"
                    style={{
                      textAlign: "left",
                      fontSize: "20px",
                      marginTop: "15px",
                      color: "#4a64f5",
                    }}
                  >
                    • 로고가 있는 경우, 로고 파일을 첨부해주셔야 진행됩니다 :)
                  </div>
                  <div
                    className="Regular1"
                    style={{
                      whiteSpace: "pre-wrap",
                      textAlign: "left",
                      marginTop: "15px",
                      color: "#898989",
                      fontSize: "20px",
                      lineHeight: "1.45",
                    }}
                  >
                    • 권장사이즈 : 최소 100 * 100px 이상.
                    <br />
                    　파일형식 : jpg, jpeg, gif, png
                    <br />
                    　파일 용량 : 최대 5MB 까지.
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <div style={{ height: "200px" }}></div>
          <div
            id="introFooter"
            onClick={saveLogo}
            style={{
              float: "right",
              backgroundColor: "#f5f6ff",
              height: "116px",
              lineHeight: "110px",
            }}
          >
            <div style={{ width: "982px", marginLeft: "calc(50% - 491px)" }}>
              <img
                loading="lazy"
                src={nextbtn}
                className={eventcss}
                style={{
                  cursor: "pointer",
                  width: "200px",
                  marginLeft: "20px",
                  marginTop: "27px",
                  float: "right",
                }}
              />
              <a href="http://pf.kakao.com/_lWuhs/chat">
                <img
                  loading="lazy"
                  src={kakaoaa}
                  style={{
                    cursor: "pointer",
                    width: "283px ",
                    marginTop: "27px",
                    float: "right",
                  }}
                />
              </a>
            </div>
          </div>
        </div>
      </BrowserView>
    </div>
  );
}

export default BrandLogoRegister;
